export const formatNumber = value => new Intl.NumberFormat('de-DE', {maximumFractionDigits: 3}).format(value);
export const formatMoney = cents => new Intl.NumberFormat('de-DE', {style:'currency',currency:'EUR'}).format(cents / 100);
export const articleKey = row => JSON.stringify([row.category_id, row.article_id, row.unit]);
export const unitLabel = (unit, whole=false) => ({half:whole ? 'Brötchen' : 'Hälften',piece:'Stück',portion:'Portionen',cup:'Tassen'}[unit] || unit);
export function calendarDays(start, end) {
  const result=[];
  for(let d=new Date(`${start}T12:00:00Z`); d.toISOString().slice(0,10)<=end; d.setUTCDate(d.getUTCDate()+1)) result.push(d.toISOString().slice(0,10));
  return result;
}
export function dashboardSummary(report) {
  const categories=new Map();
  for(const row of report.rows || []) {
    const entry=categories.get(row.category_id) || {id:row.category_id,name:row.category_name,amount:0,quantity:0,quantityOnly:!!row.quantity_only,unknown:false};
    entry.amount += row.amount_cents || 0;
    entry.quantity += row.quantity;
    entry.unknown ||= row.amount_cents == null && !row.quantity_only;
    categories.set(entry.id,entry);
  }
  return {articles:new Set((report.rows || []).map(articleKey)).size,categories:[...categories.values()].sort((a,b)=>b.amount-a.amount)};
}
export function chartSeries(report, article='', whole=false) {
  const covered=new Set(report.evaluated_dates || []);
  const daily=new Map();
  const selected=article ? (report.daily_articles || []).filter(row=>articleKey(row)===article) : (report.daily || []);
  for(const row of selected) {
    const previous=daily.get(row.date) || 0;
    daily.set(row.date, previous + (article ? row.quantity / (whole && row.unit==='half' ? 2 : 1) : (row.amount_cents || 0)/100));
  }
  const dates=calendarDays(report.start_date,report.end_date);
  const points=dates.map(date=>({date,label:new Date(`${date}T12:00:00Z`).toLocaleDateString('de-DE',{day:'2-digit',month:'2-digit',timeZone:'UTC'}),value:covered.has(date) ? (daily.get(date)||0) : null}));
  if(report.period!=='year') return points;
  const months=new Map();
  for(const point of points) {
    const key=point.date.slice(0,7), entry=months.get(key)||{date:key,label:new Date(`${key}-01T12:00:00Z`).toLocaleDateString('de-DE',{month:'short',timeZone:'UTC'}),value:0};
    entry.value=point.value==null || entry.value==null ? null : entry.value+point.value;
    months.set(key,entry);
  }
  return [...months.values()];
}
export function visibleRows(rows, search, sort, whole=false) {
  const term=search.trim().toLocaleLowerCase('de-DE');
  const result=rows.filter(row=>`${row.article_name} ${row.category_name}`.toLocaleLowerCase('de-DE').includes(term));
  const {column,direction}=tableSort(sort);
  const value=row=> {
    if(column==='name') return row.article_name;
    if(column==='unit') return unitLabel(row.unit,whole);
    if(column==='quantity') return row.quantity/(whole && row.unit==='half'?2:1);
    if(column==='price') return row.unit_price_cents == null ? null : row.unit_price_cents*(whole && row.unit==='half'?2:1);
    return row.amount_cents;
  };
  return result.sort((a,b)=> {
    const av=value(a),bv=value(b);
    if(av==null || bv==null) return av==null ? (bv==null?0:1) : -1;
    const compared=typeof av==='string'?av.localeCompare(bv,'de',{numeric:true,sensitivity:'base'}):av-bv;
    return compared*(direction==='asc'?1:-1) || a.article_name.localeCompare(b.article_name,'de');
  });
}

export function tableSort(sort) {
  const [column,explicit]=sort.split('_');
  return {column,direction:explicit || (['name','unit'].includes(column)?'asc':'desc')};
}

export function detailGroups(rows, sort='quantity_desc') {
  const groups=new Map();
  for(const row of rows) {
    let section=row.category_name,rank=4,areaId='articles',areaName='Getränke, Snacks & weitere Artikel';
    if(row.category_id==='breakfast') {
      areaId='breakfast';areaName='Frühstück';
      if(row.article_id.startsWith('roll:') || row.unit==='half') {section='Brötchen';rank=1;}
      else if(row.article_id.startsWith('topping:')) {section='Beläge';rank=2;}
      else if(row.article_id==='coffee') {section='Kaffee';rank=4;}
      else {section='Extras';rank=3;}
    } else if(['lunch','dinner'].includes(row.category_id)) {
      areaId='meals';areaName='Mittag- und Abendessen';section='';rank=0;
    } else if(row.category_id==='drinks') rank=1;
    else if(row.category_id==='snacks') rank=2;
    const id=JSON.stringify([areaId,areaId==='meals'?'meals':row.category_id,section]);
    const group=groups.get(id) || {id,areaId,areaName,section,name:areaId==='breakfast'?`Frühstück · ${section}`:section || areaName,rank,rows:[]};
    group.rows.push(row);
    groups.set(id,group);
  }
  const order={breakfast:0,meals:1,articles:2};
  const result=[...groups.values()].sort((a,b)=>order[a.areaId]-order[b.areaId] || a.rank-b.rank || a.name.localeCompare(b.name,'de'));
  for(const group of result) {
    if(group.areaId==='meals' && ['value','price','unit'].includes(tableSort(sort).column)) {
      group.rows.sort((a,b)=>(a.category_id==='lunch'?0:1)-(b.category_id==='lunch'?0:1));
    }
  }
  return result;
}
